import { useUser } from '@clerk/clerk-react';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/shared/components/ui/Button';

import { tabContainer, tabLabelColumn, tabLabelText, tabRow, tabValueText } from './settingsTab.styles';

export const AccountTab: FC = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={tabContainer}>
      <div className={tabRow}>
        <div className={tabLabelColumn}>
          <span className={tabLabelText}>{t('settings.account.email')}</span>
          <span className={tabValueText}>{user?.primaryEmailAddress?.emailAddress ?? ''}</span>
        </div>
        <Button variant="primary" onClick={() => navigate('/manage-user-account')}>
          {t('settings.account.manage')}
        </Button>
      </div>
    </div>
  );
};
